<template>
    <!-- OLD DIV VERSION    <div class="col-md-10 col-sm-9 col-md-offset-2 col-sm-offset-3 content container-fluid">-->
    <div class="col-xs-12 content container-fluid">
        <div class="modal fade" id="table-config">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close">
                        <span
                            aria-hidden="true">
                        &times;
                        </span>
                        </button>
                        <h4 class="modal-title">Configurar Listado</h4>
                    </div>
                    <div class="modal-body">
                        <div class="col-xs-12 col-lg-6">
                            <div class="checkbox check-default">
                                <input type="checkbox" checked="checked" v-model="visibleColumns" value="id">
                                <label for="checkbox1">ID de oferta</label>
                            </div>
                            <div class="checkbox check-default">
                                <input type="checkbox" checked="checked" v-model="visibleColumns" value="name">
                                <label for="checkbox1">Cliente</label>
                            </div>
                            <div class="checkbox check-default">
                                <input type="checkbox" checked="checked" v-model="visibleColumns" value="offersProvider">
                                <label for="checkbox2">Vendedor</label>
                            </div>
                            <div class="checkbox check-default">
                                <input type="checkbox" checked="checked" v-model="visibleColumns" value="amount">
                                <label for="checkbox3">Monto Total</label>
                            </div>
                            <div class="checkbox check-default">
                                <input type="checkbox" checked="checked" v-model="visibleColumns" value="fee">
                                <label for="checkbox4">Cuotas</label>
                            </div>
                        </div>
                        <div class="col-xs-12 col-lg-6">
                            <div class="checkbox check-default">
                                <input type="checkbox" checked="checked" v-model="visibleColumns" value="created_at">
                                <label for="checkbox8">Fecha/Hora</label>
                            </div>
                            <div class="checkbox check-default">
                                <input type="checkbox" checked="checked" v-model="visibleColumns" value="provider">
                                <label for="checkbox10">Sucursal</label>
                            </div>
                            <div class="checkbox check-default">
                                <input type="checkbox" v-model="visibleColumns" value="amount">
                                <label for="checkbox12">Valor de la Oferta</label>
                            </div>
                            <div class="checkbox check-default">
                                <input type="checkbox" v-model="visibleColumns" value="current_debt_amount">
                                <label for="checkbox13">Monto Restante</label>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <div class="modal-footer text-center">
                        <div class="row">
                            <div class="col-md-12">
                                <a data-dismiss="modal" class="btn btn-bgrey">CANCELAR</a>
                                <a data-dismiss="modal" class="btn btn-success">GUARDAR</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <div class="wrapper">
            <div class="container-wrapper">
                <div id="alerts-container">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-lg-6">
                <h3 class="m-0"><a href="#" class="tex-cdi-primary"></a>Ofertas</h3>
                <p>{{ offer.description }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 m-t-20">
                <div class="col-xs-12 b-t b-dashed b-transparent">
                    <div class="col-xs-12 col-lg-4 m-t-20">
                        <h4 class="tex-cdi-primary">VENTAS</h4>
                        <h2 class="tex-cdi-primary m-0">RD$ {{ offer.total_sold }}</h2>
                    </div>
                    <div class="col-xs-12 col-lg-4  b-l b-dashed b-transparent m-t-20">
                        <h4 class="tex-cdi-primary">COSTOS</h4>
                        <h2 class="tex-cdi-primary m-0">RD${{provider.accounts_to_charge}}</h2>
                        <p class="tex-cdi-primary">({{ getDate }})</p>
                    </div>
                    <div class="col-xs-12 col-lg-4 b-l b-dashed b-transparent m-t-20">
                        <h4 class="tex-cdi-primary">INGRESOS</h4>
                        <h2 class="tex-cdi-primary m-0">RD${{provider.accounts_to_pay}}</h2>
                        <p class="tex-cdi-primary">({{ getDate }})</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row m-t-20">
            <div class="col-xs-12 m-t-20 tab-content">
                <!--offer information-->
                <div class="tab-pane" id="offer-info">
                    <div class="col-xs-12 col-lg-6">
                        <div class="panel details-panel panel-default">
                            <div class="padding-20">
                                <p>ID: <span class="text-bold pull-right">#1542366652</span></p>
                                <p>Proveedor: <span class="text-bold pull-right">Óptica Oviedo</span></p>
                                <p>Representante: <span class="text-bold pull-right">Filomena Meriño</span></p>
                                <p>Teléfono del representante: <span class="text-bold pull-right">(809) 227-3017</span></p>
                                <p>Correo del representante: <span class="text-bold pull-right"> f.merino@oviedo.com</span></p>
                                <p>Vigencia de la oferta: <span class="text-bold pull-right">Temporal</span></p>
                                <p>Fecha de creación: <span class="text-bold pull-right">26/072016</span></p>
                                <p>Fecha de inicio: <span class="text-bold pull-right">26/072016</span></p>
                                <p>Fecha de expiración: <span class="text-bold pull-right">26/072016</span></p>
                                <p>Tipo de oferta: <span class="text-bold pull-right">Facilidad de pago</span></p>
                                <p>Cuotas: <span class="text-bold pull-right">4</span></p>
                                <p>Porcentaje de comisión: <span class="text-bold pull-right">5%</span></p>
                                <p>Porcentaje de descuento: <span class="text-bold pull-right">5%</span></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-6 ">
                        <div class="panel details-panel panel-default">
                            <div class="padding-20">
                                <div class="fav-img pull-right">
                                    <i class="md md-star star-ico pull-right"></i>
                                </div>
                                <div class="img-holder col-xs-12 b-a b-grey b-rad-lg center" style="background: url(../images/offer-img/offer-img.png) no-repeat center; background-size: cover;"></div>
                                <div class="clearfix"></div>
                                <div class="offer-title m-t-20">
                                    <h4>Título</h4>
                                    <p>5% de descuento y facilidad de pago en consulta y examen de la vista</p>
                                </div>
                                <div class="offer-desc">
                                    <h4>Descripción</h4>
                                    <p>Descuento de un 5% en servicios de consulta y examen visual. Con facilidad de pago en 4 cuotas.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--/.offer information-->
                <!-- clients table info-->
                <div class="tab-pane active" id="clients-table">
                    <!--table options-->
                    <div class="col-xs-12 m-t-20">
                        <div class="input-group transparent col-xs-12 col-lg-6  p-r-5 m-b-20 pull-left">
                            <input
                                :disabled="loadingTable"
                                type="text"
                                class="form-control f-text-md"
                                v-model="filterText"
                                @keypress.enter="purchasedOffersInfo()"
                                placeholder="Buscar: transacciones"
                                id="search-btn"
                                name="search-btn">
                            <span class="input-group-addon bg-white">
                            <i
                                :disabled="loadingTable"
                                @click="purchasedOffersInfo()"
                                class="md md-search sm-ico">
                            </i>
                            </span>
                        </div>
                        <a
                            class="btn btn-default download-table-btn"
                            v-link="{ name: 'new-client-offers'} ">
                        <i
                            class="glyphicon glyphicon-arrow-left">
                        </i>
                        VOLVER A CLIENTES
                        </a>
                        <button
                            class="btn btn-default download-table-btn"
                            :disabled="loadingTable"
                            @click="exportTable()">
                        <span class="glyphicon glyphicon-download-alt"></span>
                        DESCARGAR
                        </button>
                        <button
                            class="btn btn-default download-table-btn"
                            :disabled="loadingTable"
                            data-toggle="modal"
                            data-target="#table-config">
                        <span class="glyphicon glyphicon-cog"></span> CONFIGURACiÓN
                        </button>
                    </div>
                    <div class="col-xs-12 m-t-20 padding-0">
                    </div>
                    <!--/.table options-->
                    <div class="clearfix"></div>
                    <div class="table-responsive">
                        <table id="table-with-sorting" class="table data-table with-sorting table-striped tablesorter payment-batch-table sortable">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th v-show="showElement('id')">ID</th>
                                    <th v-show="showElement('created_at')">Fecha/Hora</th>
                                    <th v-show="showElement('name')" style="min-width: 165px;">Cliente</th>
                                    <th v-show="showElement('provider')" style="min-width: 183px;">Sucursal</th>
                                    <th v-show="showElement('id')" style="min-width: 270px;">Vendedor</th>
                                    <th v-show="showElement('amount')">Valor de la Oferta</th>
                                    <th v-show="showElement('amount')">Monto Total</th>
                                    <th v-show="showElement('current_debt_amount')">Monto Restante</th>
                                    <th v-show="showElement('fee')">Cuotas</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loadingTable">
                                <tr v-for="client in clients">
                                    <td>
                                        <input
                                            :value="client"
                                            v-model="checkedClients"
                                            type="checkbox">
                                    </td>
                                    <td v-show="showElement('id')">
                                        <a data-toggle="modal" @click="getTransaction(client.id)">
                                        {{ client.id }}
                                        </a>
                                    </td>
                                    <td v-show="showElement('created_at')">{{ client.created_at }}</td>
                                    <td v-show="showElement('name')">
                                        <a
                                            data-toggle="modal"
                                            @click="getTransaction(client.id)">{{ client.name }} {{ client.last_name }}
                                        </a>
                                    </td>
                                    <td
                                        v-show="showElement('provider')">
                                        {{ client.provider }}
                                    </td>
                                    <td v-show="showElement('id')"> {{provider.name}} </td>
                                    <td v-show="showElement('amount')">{{ client.amount }}</td>
                                    <td v-show="showElement('amount')">{{ client.amount }}</td>
                                    <td v-show="showElement('current_debt_amount')">{{ client.current_debt_amount }}</td>
                                    <td v-show="showElement('fee')">0</td>
                                    <td v-show="showElement('id')">
                                        <button
                                            class="btn btn-default btn-xs"
                                            @click="getLoan(client.id)"
                                            data-toggle="modal"
                                            v-if="client.current_debt_amount  > 0">
                                            APLICAR PAGO
                                        </button>
                                        <button
                                            class="btn btn-default btn-xs"
                                            @click="getTransaction(client.id)"
                                            v-else>Detalle
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <template v-if="loadingTable">
                            <div style="text-align:center">
                                <span class="fa fa-spin fa-spinner"></span>
                            </div>
                        </template>
                    </div>
                </div>
                <!-- /.clients table info-->
            </div>
        </div>
        <!-- modal-content -->
        <div class="modal fade" id="_confirmLogoutModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Logout</h4>
                    </div>
                    <div class="modal-body">
                        Esta seguro que desea salir del sistema?
                    </div>
                    <div class="modal-footer">
                        <div class="row">
                            <div class="col-md-12 pull-right">
                                <a data-dismiss="modal" class="btn btn-default">VOLVER</a>
                                <a class="btn btn-primary" id="_submitLogout">LOGOUT</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <!-- modal-content new offer-->
        <div class="modal fade  bs-example-modal-lg" id="transaction-offer">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        Detalle de Transacción
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body" v-if="transactions">
                        <div class="col-xs-12 text-right">
                            <button class="btn btn-primary m-l-5 m-r-5"><i class="md md-print sm-ico b-r b-white p-r-20 m-r-20"></i> IMPRIMIR</button>
                        </div>
                        <div class="col-xs-12 col-lg-6">
                            <div>
                                <h4 class="text-bold">Datos del cliente</h4>
                                <p>Cliente: <span class="text-bold pull-right">{{transactions.profile.first_name}} {{transactions.profile.first_surname}}</span></p>
                                <p>ID del cliente: <span class="text-bold pull-right">{{transactions.profile.identification}}</span></p>
                                <p>Empresa: <span v-if="transactions.TransactionsCompanies" class="text-bold pull-right">{{ transactions.TransactionsCompanies.name }}</span></p>
                            </div>
                            <div class="m-t-20">
                                <h4 class="text-bold">Datos del punto de venta</h4>
                                <p>ID de la transacción: <span class="text-bold pull-right">{{transactions.id}}</span></p>
                                <p>Proveedor: <span v-if="transactions.TransactionsProvider" class="text-bold pull-right">{{ transactions.TransactionsProvider.name }}</span></p>
                                <p>Sucursal: <span v-if="transactions.TransactionsProvider" class="text-bold pull-right">{{ transactions.TransactionsProvider.address }}</span></p>
                                <p>Vendedor: <span class="text-bold pull-right"></span></p>
                                <p>Canal: <span v-if="transactions.offer && transactions.offer.intern" class="text-bold pull-right">{{'Teléfono'}}</span></p>
                            </div>
                        </div>
                        <div class="col-xs-12 col-lg-6">
                            <div>
                                <h4 class="text-bold">Datos de transacción</h4>
                                <p>Fecha y hora: <span class="text-bold pull-right">{{transactions.created_at | dateFormat }}</span></p>
                                <p>Monto total: <span class="text-bold pull-right">RD {{transactions.amount | currency}}</span></p>
                                <p>Comisión total: <span v-if="transactions.offers" class="text-bold pull-right">{{ transactions.offers.comission_percent/100 *  transactions.amount| currency }}</span></p>
                                <p>No. de cuotas: <span class="text-bold pull-right">{{ transactions.payments ? transactions.payments.length : 0 }}</span></p>
                                <p>Monto de cuota: <span class="text-bold pull-right">RD ${{transactions.offer ? transactions.offer.cost : 0 }}</span></p>
                            </div>
                        </div>
                        <div class="col-xs-12 col-lg-6" v-if="selectedPayment">
                            <div>
                                <h4 class="text-bold">Datos del descuento/pago</h4>
                                <p>No. del pago: <span class="text-bold pull-right">{{selectedPayment.id}}</span></p>
                                <p>No. de cuota: <span class="text-bold pull-right">{{selectedPayment.loan_request_id}}</span></p>
                                <p>Fecha del pago de cuota: <span class="text-bold pull-right">{{ selectedPayment.created_at | dateFormat}}</span></p>
                                <p>Monto: <span class="text-bold pull-right">RD {{selectedPayment.amount | currency}}</span></p>
                                <p>Comisión del descuento: <span class="text-bold pull-right">RD {{transactions.amount | currency}}</span></p>
                                <p>Tipo de descuento: <span class="text-bold pull-right">RD {{transactions.amount | currency}}</span></p>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <hr>
                        <div class="table-responsive">
                            <table class="table table-hover table-trans m-0">
                                <thead>
                                    <tr>
                                        <th>No. del pago</th>
                                        <th>Cuota</th>
                                        <th>Fecha</th>
                                        <th>Monto</th>
                                        <th>Monto saldado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(index,payment) in transactions.payments">
                                        <tr>
                                            <td :class="[selectedPayment && payment.id == selectedPayment.id ? 'pointer click-table' : 'pointer']" @click="selectedPayment = payment" scope="row">{{payment.id}}</td>
                                            <td :class="[selectedPayment && payment.id == selectedPayment.id ? 'pointer click-table' : 'pointer']" @click="selectedPayment = payment">{{++index}}</td>
                                            <td :class="[selectedPayment && payment.id == selectedPayment.id ? 'pointer click-table' : 'pointer']" @click="selectedPayment = payment">{{payment.created_at | dateFormat}}</td>
                                            <td :class="[selectedPayment && payment.id == selectedPayment.id ? 'pointer click-table' : 'pointer']" @click="selectedPayment = payment">{{payment.amount | currency}}</td>
                                            <td :class="[selectedPayment && payment.id == selectedPayment.id ? 'pointer click-table' : 'pointer']" @click="selectedPayment = payment">{{payment.amount| currency}}</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <div>
            <!-- modal-content apply payment -->
            <div class="modal fade" id="apply-payment">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="col-xs-12 text-center">
                                <h3 class="text-bold">Aplicar pago</h3>
                                <ul class="dots-leader">
                                    <li><span>Monto pendiente</span> <span>RD${{loan.current_debt_amount }}</span></li>
                                </ul>
                            </div>
                            <div class="col-xs-12 m-t-20" v-if="loan.current_debt_amount > 0">
                                <div class="col-xs-12 col-lg-6 text-center b-r b-grey">
                                    <div class="radio radio-success text-20">
                                        <input type="radio" value="abonar" name="radio1" id="abonar-pago">
                                        <label for="abonar-pago" @click="paymentType('partial')">Abonar pago</label>
                                    </div>
                                    <p>Deberá especificar qué cantidad desea abonar a esta deuda.</p>
                                </div>
                                <div class="col-xs-12 col-lg-6 text-center">
                                    <div class="radio radio-success text-20">
                                        <input type="radio" value="saldar" name="radio1" id="saldar-pago">
                                        <label for="saldar-pago" @click="paymentType('full')">Saldar pago</label>
                                    </div>
                                    <p>Esta persona ya ha saldado su deuda por medios externos <br /> (Efectivo, cheque, etc.)</p>
                                </div>
                            </div>
                            <div class="col-xs-12 m-t-20" v-else>
                                El cliente ya saldo su prestamo
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="modal-footer text-center">
                            <div class="row">
                                <div class="col-md-12">
                                    <a class="btn btn-success">APLICAR</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- modal-content apply payment ABONAR-->
            </div>
            <div class="modal fade" id="apply-payment-abonar">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="col-xs-12 text-center">
                                <h3 class="text-bold">Aplicar pago</h3>
                                <ul class="dots-leader">
                                    <li><span>Monto pendiente</span> <span>RD${{ loan.current_debt_amount }}</span></li>
                                </ul>
                            </div>
                            <div class="col-xs-12 text-center m-t-20">
                                <h4>Abonar pago</h4>
                                <p>Deberá especificar qué cantidad desea abonar a esta deuda.</p>
                                <input class="b-rad-md b-a b-grey p-t-10 p-b-10 text-20 col-xs-12" type="text" placeholder="RD$" v-model="amount">
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="modal-footer text-center">
                            <div class="row">
                                <div class="col-md-12">
                                    <a class="btn btn-primary" data-dismiss="modal">REGRESAR</a>
                                    <a class="btn btn-success" @click="applyPayment('partial')">APLICAR</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            <!-- modal-content apply payment SALDAR-->
            <div class="modal fade" id="apply-payment-saldar">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="col-xs-12 text-center">
                                <h3 class="text-bold">Aplicar pago</h3>
                                <ul class="dots-leader">
                                    <li><span>Monto pendiente</span> <span>RD{{ loan.current_debt_amount }}</span></li>
                                </ul>
                            </div>
                            <div class="col-xs-12 text-center m-t-20">
                                <h4>Saldar pago</h4>
                                <p>Esta persona ya ha saldado su deuda por medios externos (Efectivo, cheque, etc.)</p>
                                <div class="cuota">
                                    <h3>RD${{ loan.current_debt_amount }}<i class="xl-ico text-success md md-check"></i></h3>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="modal-footer text-center">
                            <div class="row">
                                <div class="col-md-12">
                                    <a class="btn btn-primary" data-dismiss="modal">REGRESAR</a>
                                    <a class="btn btn-success" @click="applyPayment('full')">APLICAR</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            checkedClients: [],
            id: this.$route.params.id,
            companyId: this.$route.params.companyId,
            clients: [],
            loan: [],
            offer: [],
            amount: '',
            currentDebt: '',
            loadingTable: true,
            selectedPayment: null,
            provider: {},
            offerId: this.$route.params.id,
            transactions: {
                profile: {
                    first_name: ' ',
                    identification: ' ',
                    first_surname: ' ',
                },
                offers: {
                    comission_percent: ' '
                }
            },
            columnTitles: {
                id: 'Id',
                created_at: 'Fecha/Hora',
                name: 'Cliente',
                provider: 'Sucursal',
                amount: 'Valor de la Oferta',
            },
            visibleColumns: []
        }
    },

    created() {
        this.purchasedOffersInfo();
        this.getOffer();
    },
    filters: {
        dateFormat: function(date) {
            return moment(date).format("DD/MM/YYYY");
        }
    },
    methods: {
        getSortIcon() {
            if(this.sortOrder == 'ASC') {
                return 'glyphicon glyphicon-chevron-up' ;
            }
            return 'glyphicon glyphicon-chevron-down';
        },
        sort(selectedColumn, isString) {

            if (this.sortBy == selectedColumn && !isString) {
                if (this.sortOrder == 'ASC') {
                    this.sortOrder = 'DESC'
                } else {
                    this.sortOrder = 'ASC'
                }
            }

            else if (this.sortBy == selectedColumn && isString) {
                if (this.sortOrder == 'DESC') {
                    this.sortOrder = 'ASC'
                }
                else {
                    this.sortOrder = 'DESC'
                }
            }

            else if (this.sortBy !== selectedColumn && !isString) {
                this.sortOrder = 'DESC';
            }

            else if (this.sortBy !== selectedColumn && isString) {
                this.sortOrder = 'ASC'
            }

            this.sortBy = selectedColumn;
            this.purchasedOffersInfo();
        },
        /**
         * Prepares the data and exports the current page table or the selected offers
         */
        exportTable() {
            let temporaryOffersList = this.clients;
            let formattedOffersList = [];

            if (this.checkedClients.length) {
                temporaryOffersList = this.checkedClients;
            }

            for (let i = 0; i < temporaryOffersList.length; i++) {

                let temporaryContact = {};

                for (let j = 0; j < this.visibleColumns.length; j++) {

                    let columnName = this.columnTitles[this.visibleColumns[j]];

                    if (_.isObject(temporaryOffersList[i][this.visibleColumns[j]])) {
                        if (columnName) {
                            temporaryContact[columnName] = temporaryOffersList[i][this.visibleColumns[j]].name;
                        } else {
                            temporaryContact[this.visibleColumns[j]] = temporaryOffersList[i][this.visibleColumns[j]].name;
                        }
                    } else {

                        if (columnName) {
                            if (this.visibleColumns[j] == 'validity') {
                                let validity = temporaryOffersList[i][this.visibleColumns[j]] == "0" ? 'Indefinida' : 'Temporal';
                                temporaryContact[columnName] = validity;
                            } else if (columnName.includes("Fecha")) {
                                temporaryContact[columnName] = moment(temporaryOffersList[i][this.visibleColumns[j]]).format("DD/MM/YYYY");
                            } else {
                                temporaryContact[columnName] = temporaryOffersList[i][this.visibleColumns[j]];
                            }
                        } else {
                            temporaryContact[this.visibleColumns[j]] = temporaryOffersList[i][this.visibleColumns[j]];
                        }
                    }

                }

                formattedOffersList.push(temporaryContact);
            }

            this.JSONToCSVConvertor(formattedOffersList, `Listado de Ofertas - Página`, true);
        },

        /**
         * Converts a JSON string to a CVS file (Excel readable file)
         *
         * @param      {string}  ReportTitle  The report title
         * @param      {boolean} ShowLabel    Flag that shows/hides the report title in the document
         */
        JSONToCSVConvertor(List, ReportTitle, ShowLabel) {

            let JSONData = JSON.stringify(List);

            //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
            var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

            var CSV = '';
            //Set Report title in first row or line

            CSV += ReportTitle + '\r\n\n';

            //This condition will generate the Label/Header
            if (ShowLabel) {
                var row = "";
                //This loop will extract the label from 1st index of on array
                for (var index in arrData[0]) {

                    //Now convert each value to string and comma-seprated
                    row += index + ',';
                }

                row = row.slice(0, -1);

                //append Label row with line break
                CSV += row + '\r\n';
            }

            //1st loop is to extract each row
            for (var i = 0; i < arrData.length; i++) {
                var row = "";

                //2nd loop will extract each column and convert it in string comma-seprated
                for (var index in arrData[i]) {
                    row += '"' + arrData[i][index] + '",';
                }

                row.slice(0, row.length - 1);

                //add a line break after each row
                CSV += row + '\r\n';
            }

            if (CSV == '') {
                alert("Invalid data");
                return;
            }

            //Generate a file name
            var fileName = ReportTitle;

            //Initialize file format you want csv or xls
            var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

            // Now the little tricky part.
            // you can use either>> window.open(uri);
            // but this will not work in some browsers
            // or you will not get the correct file extension

            //this trick will generate a temp <a /> tag
            var link = document.createElement("a");
            link.href = uri;

            //set the visibility hidden so it will not effect on your web-layout
            link.style = "visibility:hidden";
            link.download = fileName + ".csv";

            //this part will append the anchor tag and remove it after automatic click
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        purchasedOffersInfo: function() {
            this.loadingTable = true;
            this.$http.get(apiUrl + '/company/' + this.companyId + '/offers/' + this.id).then(response => {
                this.clients = response.data;
                this.loadingTable = false;
            });
        },
        showElement(elementName) {
            return this.visibleColumns.includes(elementName);
        },
        getTransaction: function(id) {
            this.loadingTable = true;
            this.$http.get(apiUrl + '/transactions/' + id + '?relationships=offers,profile,payments,TransactionsProvider,employees,TransactionsCompanies,loanSplits').then(response => {
                this.transactions = response.data;

                if (response.data.payments.length) {
                    this.selectedPayment = response.data.payments[0];
                } else {
                    this.selectedPayment = null;
                }
                this.loadingTable = false;
                $('#transaction-offer').modal('show');
            });
        },

        getLoan: function(id) {
            console.log("what");
            let fillLoan = this.clients.find((client) => {
                return client.id == id;
            });

            this.loan = fillLoan;
            $('#apply-payment').modal('show');

        },

        paymentType: function(type) {
            if (type == 'partial') {
                $('#apply-payment-abonar').modal('show');
            } else if (type == 'full') {
                $('#apply-payment-saldar').modal('show');
            }
        },

        getOffer: function() {
            this.$http.get(apiUrl + '/offers/' + this.offerId).then(response => {
                this.offer = response.data;
                this.getProvider();

            });
        },
        getProvider: function() {
            this.$http.get(apiUrl + '/providers/' + this.offer.provider_id).then(response => {
                this.provider = response.data;
                //this.selectedProvider = response.data.name;
            });
        },
        applyPayment: function(type) {
            let self = this;

            if (type == 'partial')
                if (this.loan.current_debt_amount == '0') {
                    swal("Error !", "El cliente ya pago su deuda", "error")
                } else {
                    if (parseInt(this.amount) > parseInt(this.loan.current_debt_amount)) {
                        alert('Error ! el monto a pagar es mayor que la deuda');
                    } else {
                        let total = +this.loan.current_debt_amount - +this.amount;

                        $.ajax({
                            url: apiUrl + '/users/' + this.loan.user_id + '/loan/' + this.loan.id + '/payment',
                            type: 'PUT',
                            data: {
                                'id': this.loan.id,
                                'payed_amount': this.amount,
                                'payment_type': 'partial'
                            },
                            success: function(response) {
                                swal("Felicidades !", "pago realizado exitosamente !", "success");
                                $('#apply-payment-abonar').modal('toggle');
                                $('#apply-payment').modal('toggle');
                                self.purchasedOffersInfo();
                                self.amount = '';
                            },
                            error: function(request, error) {
                                swal("Error !", "Ha ocurrido un error al intentar procesar el pago !", "error")
                            }
                        });
                    }
                }
            else if (type == 'full') {
                let fullAmount = this.loan.current_debt_amount - this.loan.current_debt_amount
                if (this.loan.current_debt_amount == '0') {
                    swal("Error !", "El cliente ya pago su deuda", "error")
                } else {
                    $.ajax({
                        url: apiUrl + '/users/' + this.loan.user_id + '/loan/' + this.loan.id + '/payment',
                        type: 'PUT',
                        data: {
                            'id': this.loan.id,
                            'payed_amount': this.loan.current_debt_amount,
                            'payment_type': 'full'

                        },
                        success: function(response) {
                            swal("Felicidades !", "pago total del prestamo realizado exitosamente !", "success");
                            $('#apply-payment-saldar').modal('toggle');
                            $('#apply-payment').modal('toggle');
                            self.purchasedOffersInfo();
                            self.amount = '';
                        },
                        error: function(request, error) {
                            swal("Error !", "Ha ocurrido un error al intentar procesar el pago !", "error")
                        }
                    });
                }
            }
        },
    },
    computed: {
        getDate: function() {
            var today = new Date();
            var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
            return date;
        },
    }
}
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }
    .click-table {
        background-color: #f9ebeb;
    }
</style>



// WEBPACK FOOTER //
// offers-clients-info.vue?64b36496